import {
  GROCERY_PAGE,
  CLOTHING,
  MAKEUP_PAGE,
  BAGS_PAGE,
  FURNITURE_PAGE,
  BOOK_PAGE,
  MEDICINE_PAGE,
  RESTAURANT_PAGE,
} from "./navigation";
export default [
  {
    link: GROCERY_PAGE,
    icon: "",
    label: "Grocery",
  },
  {
    link: MAKEUP_PAGE,
    icon: "",
    label: "Makeup",
  },
  {
    link: BAGS_PAGE,
    icon: "",
    label: "Bags",
  },
  {
    link: CLOTHING,
    icon: "",
    label: "Clothing",
  },
  {
    link: BOOK_PAGE,
    icon: "",
    label: "Book",
  },
  {
    link: FURNITURE_PAGE,
    icon: "",
    label: "Furniture",
  },
  {
    link: MEDICINE_PAGE,
    icon: "",
    label: "Medicine",
  },
  {
    link: RESTAURANT_PAGE,
    icon: "",
    label: "Foods",
  },
];
